import { render, staticRenderFns } from "./ModifierLists.vue?vue&type=template&id=37435be3&"
import script from "./ModifierLists.vue?vue&type=script&lang=js&"
export * from "./ModifierLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports